import axios from "axios";
import { generateNonce, generateSignature_v2 } from '@/utils/crypt.util.js'
import { ElMessage } from 'element-plus'
import { getToken } from "@/utils/cookies"
import { debounce } from './common'

const locale =  require('@/lang/index.js').default.global.locale;
const t =  require('@/lang/index.js').default.global.t

// import { debounce } from 'lodash';
import router from '@/router/index.js'
//创建axios实例
let requests = axios.create({
  //基础路径
  baseURL: "/",
  //请求不能超过10S
  timeout: 10000,
});


//请求拦截器（）
requests.interceptors.request.use((config) => {
  const appId = '202007190935006'
  const timestamp = new Date().getTime()
  const nonce = generateNonce(timestamp)
  let url = config.url.replace("/api", "");
  url = url.replace("/robot", "")
  if (url.indexOf("?") > 0) {
    url = url.substring(url.indexOf("?"), -1);
  }
  let method = config.method.toUpperCase();
  const signature = generateSignature_v2(appId, timestamp, nonce, method, url);
  config.headers = {
    signature,
    appId,
    nonce,
    timestamp,
    token:getToken(),
    source:1,
    language: locale.value === 'en' ? 'en_US' : 'zh_CN'
  }

  return config;
});
//统一提示信息
let debounceMes = debounce((res) => {
  ElMessage({
    message: res.data.message,
    customClass: "custom-message2",
  })
}, 1000)
//响应拦截器（）
requests.interceptors.response.use(
  (res) => {
    if (res.data.code === 9999404){
      router.go(-1)
    }
    //响应成功
    if (res.data.code !== 200) {
      debounceMes(res)
    }
    // if (res.data.code === 9999403){
    //   router.push('/home/find')
    // }
    
    return res.data;
  },
  (err) => {
    //响应失败
    console.log(err);
    ElMessage({
      message: t('verificationTips.serviceErrorTips'),
      customClass: "custom-message2",
    })
  }
);
export default requests;